import styled from 'styled-components';

import KiperButton from '../KiperButton';

export const StyledKiperButton = styled(KiperButton)``;
